module.exports = __webpack_public_path__ + "static/media/PWA_logo.666ee1f3.png";